<template>
  <div>



    <div class="line-chart-container">
      <div class="control-panel">
        <!-- 日期选择器 -->
        <el-date-picker
          v-model="selectedDateRangeLineEvery"
          type="date"
          :picker-options="pickerOptionsLineEvery"
          :editable="false"
          @input="handleDateInputLineEvery"
        ></el-date-picker>

        <!-- 时间范围按钮 -->
      </div>

      <!-- 折线图容器 -->
      <div class="line-chart" :ref="'lineChartEvery'">

      </div>
      <div class="chart-titleTotol">各模块使用时长和点击次数</div>


    </div>










  </div>


</template>

<script>
import * as echarts from 'echarts';
import chinaMap from "@/assets/json/china.json";
import axios from "axios";
import fa from "element-ui/src/locale/lang/fa";
import Fa from "element-ui/src/locale/lang/fa";

export default {
  data() {

    return {
      message:20,
      // 各模块的数据
      selectedDateRangeLineEvery: new Date(), // 默认为今天
      lineChartEvery: null,
      dataLineEvery: [
        // ...更多数据
      ],
      pickerOptionsLineEvery: {
        disabledDate: (time) => {
          const date = new Date(time);
          return date < new Date('2023-03-01') || date > new Date();
        },
      },
      // 红包分布的数据

    };
  },




  mounted() {

//初始化时间和柱状图
//     this.getInfo();
    const currentDate = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(currentDate.getDate() - 7);
    const startDate = this.formatDate(oneWeekAgo);
    const endDate = this.formatDate(currentDate);

    this.selectedDateRangeLineEvery=endDate
    this.lineChartEvery = echarts.init(this.$refs.lineChartEvery);
    this.getLineAndEvery()

  },

  methods: {

    //对年龄进行析出




    // 各自模块的点击次数的折线图和柱状图
    async getLineAndEvery(){
      this.lineChartEvery.showLoading({
        text : '暂无数据',
        effectOption: {backgroundColor: 'transparent'}
      })

      try {

        axios.get('/v1/admin/page-share-count?begin_date='+this.selectedDateRangeLineEvery+ '&end_date=' + this.selectedDateRangeLineEvery)
          .then(response => {
            // 处理返回的数据
              console.log(response.data)
            if (response.data.status === 'success') {
              this.dataLineEvery=[]
              const length=response.data.data.length

              for(let i =0;i<length;i++){
                const data=response.data.data[i]
                this.dataLineEvery.push(data)
                if(i==length-1){
                  this.initLineChartLineEvery();
                }
              }
            } else {
              this.$msg(response.data.msg);
            }



          })
          .catch(error => {
            // 处理错误
            console.error(error);
          });




      }
      catch (error) {
        console.error('获取数据失败：', error);
      }

    },








    formatDate(dateObject) {
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const day = String(dateObject.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },


    initLineChartLineEvery() {
      this.updateLineChartEvery();
    },

    //更新数据用


    updateLineChartEvery() {
      // 更新折线图数据

      const selectedDataLine = this.dataLineEvery

      const optionLine = {
        grid: {
          right: '20%'
        },
        tooltip: {
          trigger: 'axis', // 设置为 'axis'，即在坐标轴上显示 tooltip
        },

        // dimensions: ["金额", "2020年累计消费", "2021年累计消费"],
        // 配置折线图选项

        xAxis: {
          type: 'category',
          data: selectedDataLine.map(item => item.content),
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
            rotate: -20, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 6, // 刻度标签与轴线之间的距离
            formatter: '{value}', // 刻度标签的内容格式器
          },
        },

        legend: {
          data: ['点击次数',],
        },

        yAxis: [
          {
            type: 'value',
            name: '点击次数',
            alignTicks: true,
            axisLine: {
              show: true,
            },

          },


        ],
        series: [
          {
            name: '点击次数',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            barWidth: '20%',
            data: selectedDataLine.map(item => item.count),
          },

        ],
      };
      this.lineChartEvery.hideLoading();
      this.lineChartEvery.setOption(optionLine);
    },

    formatDuration(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secondsRemain = seconds % 60;
      return `${hours}时${minutes}分${secondsRemain}秒`;
    },
    handleDateInputLineEvery(value) {
      // 设置选定的时间范围
      this.selectedDateRangeLineEvery = this.formatDate(value);

      this.getLineAndEvery();
    },

  },

};
</script>

<style scoped>
.bar-container {
  padding: 20px;
}

.chart-container {
  position: relative;
}
.chart-container1{
  position: relative;
  height: 400px;
}
.dataSelet{
  position: absolute;
  left: 0;
  top: 20px;
}
.chart {
  height: 450px;
}
.ExportRecord{
  position: absolute;
  top: -10px;
  left: 90%;
  display: flex;
  line-height: 15px;
  align-items: center;

}
.chart222 {
  height: 600px;
}

.loadingChart{

  height: 450px;
  width:100%;
  position:absolute;

}
.dropdown-container {
  display: flex;
  align-items: center;
}

.dropdown {
  /*margin-right: 10px;*/
}
.pie-container {
  padding: 20px;
}

.pie-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.pie-col {
  flex: 0 0 calc(50% - 20px);
  margin-bottom: 20px;
}

.el-card {
  border: none;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.chart-container {
  position: relative;
}

.chart {
  height: 300px;
}

.chart-title1 {
  padding: 10px;
  background-color: #f2f2f2;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.chart-titleTotol {
  padding: 10px;
  background-color: #f2f2f2;
  width: 100%;
  margin: 0 auto;
  /*text-align: center;*/
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.chart-title {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.bar-container {
  margin-top: 20px;
}

.selection-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.el-radio-group {
  margin-right: 20px;
}
.map-container {
  margin-top: 50px;
  position: relative;
  width: 100%;
  height: 950px; /* 设置地图容器的高度 */
}

/* 地图图表样式 */
.map-chart,
.chartMap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;


}
.chartMap{
  z-index: 2;
  top: 25%;
  left: 60%;
  width: 35%;
  height: 35%;
}

.line-chart-container {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.control-panel {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.range-buttons {
  margin-left: 20px;
}

.line-chart {

  width: 100%;
  height: 430px;
}

</style>



// WEBPACK FOOTER //
// src/pages/ShareClicksNumber/ShareClicksNumber.vue